export const buyButtonStyle = {
    align: 'center',
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: [
        '#f48e0c',
        '#fff88b',
        '#f9ffd5',
        '#fff88b',
        '#ffcb2a',
        '#ffcb2a',
        '#f48e0c'
    ],
    stroke: '#84230f',
    strokeThickness: 10,
    fontSize: 60
};

export const buyPopUpStyle = {
    align: 'center',
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: [
        '#f48e0c',
        '#fff88b',
        '#f9ffd5',
        '#fff88b',
        '#ffcb2a',
        '#ffcb2a',
        '#f48e0c'
    ],
    stroke: '#84230f',
    strokeThickness: 10,
    fontSize: 190
};

export const buyPopUpNotEnoughRubyStyle = {
    align: 'center',
    fill: ['#818181'],
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 100,
    fontWeight: 'bold',
    strokeThickness: 8
};

export const buyPopUpBetStyle = {
    align: 'center',
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: [
        '#f48e0c',
        '#fff88b',
        '#f9ffd5',
        '#fff88b',
        '#ffcb2a',
        '#ffcb2a',
        '#f48e0c'
    ],
    stroke: '#84230f',
    strokeThickness: 10,
    fontSize: 150
};

export const costInRubiesStyle = {
    fill: '#e10000',
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 190,
    fontWeight: 'bold',
    lineJoin: 'bevel',
    miterLimit: 0,
    stroke: 'white',
    strokeThickness: 8
};